import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function AdvisoryTeaser() {
  return (
    <section
      data-testid="advisory-teaser"
      className="relative bg-[var(--charcoal)] text-[var(--cream)] py-24 lg:py-32 grain overflow-hidden"
    >
      <div className="beam-glow pointer-events-none absolute inset-0 opacity-60" />
      <div className="container-luxe relative z-10 grid lg:grid-cols-[1.15fr_0.85fr] gap-12 items-end">
        <Reveal>
          <p className="overline flex items-center gap-3 text-[var(--gold-soft)]">
            <span className="h-px w-8 bg-[var(--gold)]" />
            Introducing · Hospitality Advisory
          </p>
          <h2 className="mt-6 serif text-[clamp(1.9rem,4vw,3.2rem)] leading-[1.06] tracking-tight">
            Now advising the properties behind{" "}
            <span className="italic text-[var(--gold-soft)]">five-star stays.</span>
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-[var(--cream)]/70">
            Boutique hotels, luxury resorts, retreats, and high-end rentals — take the
            FREE Time-Wealth Audit and see exactly where your operation is
            spending your hours.
          </p>
        </Reveal>
        <Reveal delay={0.15} className="lg:justify-self-end">
          <Link
            to="/hospitality-advisory"
            data-testid="advisory-teaser-cta"
            className="group inline-flex items-center gap-3 bg-[var(--gold)] px-8 py-4 text-sm text-[var(--charcoal)] hover:bg-[var(--gold-light)] transition-colors duration-400"
          >
            Explore Hospitality Advisory
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
